import { memo, useEffect, useMemo, useState, } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { ORDER_PRODUCT_TYPES, ORDER_VALIDITY } from "../../utils/global_variables";
import { getAveragePrice } from "../../utils/global_functions";
import ZeroStates from "../ZeroStates";
import _ from "lodash";
import moment from "moment";
import StatusChip from "./StatusChip";

const TradesTable = ({ data }) => {

    const arrTradeData = useMemo(() => {
        let arr = [{ heading: 'Trades', data: data }];
        if (data?.prodType === ORDER_PRODUCT_TYPES.BRACKET) {
            arr = [
                { heading: 'Trades', data: { ...data, status: data?.mainLegStatus } },
                { heading: 'Profit Leg', data: data['Profit Leg'] },
                { heading: 'Stop Loss Leg', data: data['Stop Loss Leg'] },
                { heading: 'Exit Leg', data: data['Exit Leg'] },
            ];
        }
        return arr;
    }, [data]);




    //Azeem K 23-07-2025 : commented as of now modify,cancel,reorder buttons is not showing ---Start
    // const dispatch = useDispatch();
    // const handleModifyOrder = useCallback(() => {
    //     const scripData = getArrSingleScripOrderInfo(data);
    //     //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    //     const isBuySell = (data?.type || data?.transaction_type) === "BUY" ? 0 : 1;
    //     if (scripData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
    //         //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - Start
    //         || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
    //         //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes -End
    //         var nQuantity = data?.pendingQuantity;
    //         var nLot = parseInt(data?.pendingQuantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
    //     } else {
    //         nLot = data?.pendingQuantity;
    //         nQuantity = parseInt(data?.pendingQuantity) * scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
    //     }
    //     //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
    //     let nDisclosedQty = data?.disclosed_quantity;
    //     if (scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
    //         nDisclosedQty = parseInt(data?.disclosed_quantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
    //     }
    //     //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
    //     if (data?.validity === ORDER_VALIDITY.GTD) {
    //         ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: data?.price, scripQuantity: nQuantity, slTrigger: data?.trigger_price, gtdDate: dayjs(moment(data?.validity_date).format('DD-MM-YYYY'), 'DD-MM-YYYY') }));
    //         ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: data?.product_type || data?.prodType, productTypeDesc: data?.prodTypeDesc || data?.productTypeDesc, validityTypes: data?.validity, orderType: data?.order_type || data?.orderType, isAmo: data?.is_amo_order, isDefaultProductType: false }));
    //         //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    //     } else {
    //         // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    //         ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: data?.price, scripQuantity: nQuantity, slTrigger: data?.trigger_price, scripLot: nLot, discQty: nDisclosedQty }));
    //         ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: data?.prodType, productTypeDesc: data?.productTypeDesc, validityTypes: data?.validity, orderType: data?.orderType, isAmo: data?.is_amo_order, isDefaultProductType: false }));
    //         // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    //     }
    //     dispatch(handleModalData({ orderData: data }));
    //     dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData, isModifyOrder: true, nOriginalQty: nQuantity }));
    //     dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));

    // }, [dispatch, data]);

    // const handleCancelOrder = useCallback(() => {
    //     //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    //     // const scripData = getArrSingleScripOrderInfo(data);
    //     // const isBuySell = data?.type === "BUY" ? 0 : 1;
    //     dispatch(getOrderInfo(data));
    //     // dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData }));
    //     dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': true }], true));
    //     //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    // }, [data, dispatch]);
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    // const bIsCancelButton = useMemo(() => {
    //     return data?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || data?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || data?.status === ALL_ORDERS_STATUS.PARTIALLY_COMPLETED || data?.status === ORDER_STATUS_FROM_RESPONSE.OMS_XMITTED || data?.status === ORDER_STATUS_FROM_RESPONSE.OMSXMITTED_MAIN || data?.status === ORDER_STATUS_FROM_RESPONSE.ACTIVE || data?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED || data?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN;

    // }, [data]);
    // const bIsModifyButton = useMemo(() => {
    //     return data?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || data?.status === ORDER_STATUS_FROM_RESPONSE.PARTIALLYCOMPLETED_MAIN || data?.status === ORDER_STATUS_FROM_RESPONSE.AMOACCEPTED_MAIN || data?.status === ORDER_STATUS_FROM_RESPONSE.ACTIVE;

    // }, [data]);
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End

    // const handleReOrder = useCallback(() => {
    //     const scripData = getArrSingleScripOrderInfo(data);
    //     //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    //     const isBuySell = (data?.type || data?.transaction_type) === "BUY" ? 0 : 1;
    //     // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    //     if (scripData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
    //         //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - Start
    //         || scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
    //         //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes -End
    //         var nQuantity = data?.totalQuantity;
    //         var nLot = parseInt(data?.totalQuantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
    //     } else {
    //         nLot = data?.totalQuantity;
    //         nQuantity = parseInt(data?.totalQuantity) * scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
    //     }
    //     //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
    //     let nDisclosedQty = data?.disclosed_quantity;
    //     if (scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
    //         nDisclosedQty = parseInt(data?.disclosed_quantity) / scripData[WATCHLIST_GRID_INDEX.REGULAR_LOT];
    //     }
    //     //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End

    //     if (data?.validity === ORDER_VALIDITY.GTD) {
    //         ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: data?.price, scripQuantity: nQuantity, slTrigger: data?.trigger_price, gtdDate: dayjs(moment(data?.validity_date).format('DD-MM-YYYY'), 'DD-MM-YYYY') }));
    //         ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: data?.product_type || data?.prodType, productTypeDesc: data?.prodTypeDesc || data?.productTypeDesc, validityTypes: data?.validity, orderType: data?.order_type || data?.orderType, isAmo: data?.is_amo_order, isDefaultProductType: false }));
    //     } else {
    //         //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    //         // Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    //         ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: data?.price, scripQuantity: nQuantity, slTrigger: data?.trigger_price, scripLot: nLot, discQty: nDisclosedQty }));
    //         ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, productType: data?.prodType, productTypeDesc: data?.productTypeDesc, validityTypes: data?.validity, orderType: data?.orderType, isAmo: data?.is_amo_order, isDefaultProductType: false }));
    //     }
    //     dispatch(handleModalData({ orderData: data }));
    //     dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData, isReOrder: true }));
    //     dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));

    // }, [data, dispatch]);
    //Azeem K 23-07-2025 : commented as of now modify,cancel,reorder buttons is not showing ---End


    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    const Table = ({ data }) => {
        // Vaibhav S : 26-02-2024 :  added average price calculation:Start
        const [numAvgPrice, setNumAvgPrice] = useState((0).toFixed(2));
        useEffect(() => {
            if (data?.trades?.length) {
                const averagePrice = getAveragePrice(data?.trades);
                setNumAvgPrice(averagePrice);
            } else {
                setNumAvgPrice((0).toFixed(2));
            }
        }, [data]);
        // Vaibhav S : 26-02-2024  added average price calculation:End
        if (data?.validity === ORDER_VALIDITY.GTD) {
            return (
                <table className='table table-hover table-bordered table-striped'>
                    <thead>
                        <tr>
                            <th className='text-center'>
                                <div className='font-size2 color-text text-capitalize py-2'>Date</div>
                            </th>
                            <th className='text-center'>
                                <div className='font-size2 color-text text-capitalize py-2'>Order No</div>
                            </th>
                            <th className='text-center'>
                                <div className='font-size2 color-text text-capitalize py-2'>Qty</div>
                            </th>
                            <th className='text-end pe-5'>
                                <div className='font-size2 color-text text-capitalize py-2'>Price</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.trades?.length > 0 &&
                            data?.trades?.map((item, id) => {
                                return (
                                    <tr key={id}>
                                        <td className='text-center'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{moment(data?.order_date).format("D MMM'YY")}</div>
                                        </td>
                                        <td className='text-center'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.trade_no}</div>
                                        </td>
                                        <td className='text-center'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.trade_quantity}</div>
                                        </td>
                                        <td className='text-end pe-5'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.trade_price}</div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                        <tr>
                            <td className='bdr-rgt-none'>&nbsp;</td>
                            <td className='bdr-lft-none bdr-rgt-none'>&nbsp;</td>
                            <td className='bdr-lft-none bdr-rgt-none text-center'>
                                <div className='font-medium font-size2 color-text text-capitalize py-1'>{_.sumBy(data?.trades, (obj) => Number(obj.trade_quantity))}</div>
                            </td>
                            <td className='bdr-lft-none text-end pe-5'>
                                <div className='font-regular font-size1 color-text text-capitalize py-1'>Average Price : <span className='font-medium font-size2 color-text text-capitalize'>{` ${numAvgPrice}`}</span></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        } else {
            return (
                <table className='table table-hover table-bordered table-striped'>
                    <thead>
                        <tr>
                            <th className='text-center'>
                                <div className='font-size2 color-text text-capitalize py-2'>Time</div>
                            </th>
                            <th className='text-center'>
                                <div className='font-size2 color-text text-capitalize py-2'>Trade No</div>
                            </th>
                            <th className='text-center'>
                                <div className='font-size2 color-text text-capitalize py-2'>Qty</div>
                            </th>
                            <th className='text-end pe-5'>
                                <div className='font-size2 color-text text-capitalize py-2'>Price</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.trades?.length > 0 &&
                            data?.trades?.map((item, id) => {
                                return (
                                    <tr key={id}>
                                        <td className='text-center'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{moment(item?.trade_timestamp).format("hh:mm:ss A, DD MMM 'YY")}</div>
                                        </td>
                                        <td className='text-center'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.trade_no}</div>
                                        </td>
                                        <td className='text-center'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.trade_quantity}</div>
                                        </td>
                                        <td className='text-end pe-5'>
                                            <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.trade_price}</div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                        <tr>
                            <td className='bdr-rgt-none'>&nbsp;</td>
                            <td className='bdr-lft-none bdr-rgt-none'>&nbsp;</td>
                            <td className='bdr-lft-none bdr-rgt-none text-center'>
                                {/* Azeem K : 13-12-2023 :BT-101818 : Order Book - Single Scrip Order –--Start */}
                                <div className='font-medium font-size2 color-text text-capitalize py-1'>Total Qty : <span className='font-medium font-size2 color-text text-capitalize'>{_.sumBy(data?.trades, (obj) => Number(obj.trade_quantity))}</span></div>
                                {/* Azeem K : 13-12-2023 :BT-101818 : Order Book - Single Scrip Order –--End */}

                            </td>
                            <td className='bdr-lft-none text-end pe-5'>
                                <div className='font-regular font-size1 color-text text-capitalize py-1'>Average Price : <span className='font-medium font-size2 color-text text-capitalize'>{` ${numAvgPrice}`}</span></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        }
    };
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End

    return (

        <Container fluid className='p-0'>
            {arrTradeData?.map((each) => {
                return (
                    <Row className='g-0'>
                        <Col md={5} className='mrgauto p-3'>
                            <Row className='g-0 my-3'>
                                <Col className='d-flex justify-content-start align-items-center' md={6}>
                                    <div className='font-medium font-size4 color-text'>{each?.data?.validity === ORDER_VALIDITY.GTD ? 'Order History' : each?.heading}</div>
                                    {each?.data?.status && each?.data?.product_type === ORDER_PRODUCT_TYPES.BRACKET && <StatusChip data={each?.data} bisEnlargementClass={true} />}
                                </Col>
                                {/* Azeem K : 21-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */}
                                {/* {data?.is_amo_order ? <Col md={2}>
                            <Container fluid className='p-0'>
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-end align-items-center py-2'>
                                        <div className='chips-wrap'>
                                            <BzChip className={`chips negative-chip text-capitalize`}>
                                                AMO
                                            </BzChip>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col> : null} */}
                                {/* Azeem K : 21-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}
                                {/* <Col className='d-flex justify-content-end align-items-center'>
                            <BzButton className='btn btn-sm btn-outline text-capitalize ms-3' onClick={handleReOrder}>RE-ORDER</BzButton>
                            {bIsCancelButton && <BzButton className='btn btn-sm btn-outline text-capitalize ms-3' onClick={handleCancelOrder}>CANCEL ORDER</BzButton>}
                            {bIsModifyButton && <BzButton className='btn btn-sm btn-primary text-capitalize ms-3' onClick={handleModifyOrder}>MODIFY</BzButton>}

                        </Col> */}
                            </Row>
                            <Row className='g-0'>
                                <Col className='bdr'>
                                    {
                                        each?.data?.trades?.length > 0 ?
                                            <Table data={each?.data} />
                                            :
                                            <div className='zero-state-alerts zero-state-alerts-sm'>
                                                <ZeroStates subText="No trades happened yet" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                            </div>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                );
            })}
        </Container>

    );
};

export default memo(TradesTable);
